// extracted by css-extract-rspack-plugin
export default {"indicatorContainer":"indicatorContainer-Z1okRF"};